// extracted by mini-css-extract-plugin
var _1 = "CourseHeader_center__10020";
var _2 = "CourseHeader_disabled__79813";
var _3 = "CourseHeader_floatingButton__7d9ea";
var _4 = "CourseHeader_headerRightFix__f8e65";
var _5 = "CourseHeader_logo__6d7b5";
var _6 = "CourseHeader_positionRight__5c055";
var _7 = "CourseHeader_title__2e47c";
export { _1 as "center", _2 as "disabled", _3 as "floatingButton", _4 as "headerRightFix", _5 as "logo", _6 as "positionRight", _7 as "title" }
